import React from 'react';
import { useLocale } from '../contexts/LocaleContext';
import { AddResourceMenu } from './AddResourceMenu';
import { PanelEmptyState } from './PanelEmptyState';
import { ResourcesEmptyIllustration } from './ResourcesEmptyIllustration';

interface ResourcesEmptyStateProps {
  canEdit: boolean;
  onAddText: () => void;
  onAddLink: () => void;
  onAddDocument: () => void;
}

export const ResourcesEmptyState: React.FC<ResourcesEmptyStateProps> = ({
  canEdit,
  onAddText,
  onAddLink,
  onAddDocument,
}) => {
  const { t } = useLocale();

  return (
    <PanelEmptyState
      illustration={<ResourcesEmptyIllustration />}
      title={t('resources_empty_title')}
      description={t('resources_empty_description')}
      actions={
        canEdit ? (
          <AddResourceMenu onAddText={onAddText} onAddLink={onAddLink} onAddDocument={onAddDocument} />
        ) : undefined
      }
    />
  );
};
